import { useMutation } from '@tanstack/react-query';
import { graphqlRequest } from '@/api/amplify/helpers';
import { deleteApp } from '@/graphql/mutations';
import { reactQueryClient } from '../react-query/query-client';
import { useCurrentApp } from '@/stores/userDataStore';

export const useDeleteApp = () => {
  const { appKey } = useCurrentApp();

  const { mutate: deleteAppMutation } = useMutation({
    mutationFn: async (appId: string) => {
      await graphqlRequest({
        query: deleteApp,
        variables: { input: { id: appId } },
      });
    },
    onSuccess: () => {
      reactQueryClient.invalidateQueries({
        queryKey: ['useAppsByAppKey', appKey],
      });
      reactQueryClient.invalidateQueries({
        queryKey: ['useAppsByAppKeyPolling', appKey],
      });
    },
  });

  return deleteAppMutation;
};
